import DOMPurify from 'dompurify';

export class ConvertSvg {
  constructor() {
    this.$hasSvg = $('img.img-svg:not(.lazy)')
  }

  appendSvg(data, $img) {
    const imgID = $img.attr('id')
    const imgClass = $img.attr('class')
    const $tmpSvg = $(data).find('svg');
    const cleanData = DOMPurify.sanitize($tmpSvg.get(0), { USE_PROFILES: { svg: true } });
    let $svg = $(cleanData);
    if (typeof imgID !== 'undefined') {
      $svg = $svg.attr('id', imgID)
    }
    $svg = $svg.attr('class', `${imgClass} replaced-svg`)
    $svg = $svg.removeAttr('xmlns:a')
    if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
      $svg.attr('viewBox', `0 0 ${$svg.attr('height')} ${$svg.attr('width')}`)
    }
    if ($svg.length) {
      $img.replaceWith($svg)
    }
  }

  convertSvg() {
    if (this.$hasSvg.length) {
      this.$hasSvg.each((_index, e) => {
        const $img = $(e)
        const imgURL = $img.attr('src')
        if (imgURL) {
          $.get(
            imgURL,
            (data) => {
              this.appendSvg(data, $img)
            },
            'xml',
          )
        }
      })
    }
  }
}

export default (() => {
  new ConvertSvg().convertSvg()
})()
